export default "__VITE_ASSET__CIOZ1fHb__"